import { ContextOutOfBoundsError } from "providers/ContextOutOfBoundsError";
import { createContext, ReactNode, useContext } from "react";
import { ToolDetails } from "./PageToolQuery";

type ToolContextValue = {
  tool: ToolDetails;
  invalidateToolQuery: () => Promise<void>;
};

const ToolDataContext = createContext<ToolContextValue | undefined>(undefined);

interface ToolDataProviderProps {
  children: ReactNode;
  tool: ToolDetails;
  invalidateToolQuery: () => Promise<void>;
}

export const ToolDataProvider = ({
  children,
  tool,
  invalidateToolQuery,
}: ToolDataProviderProps) => {
  return (
    <ToolDataContext.Provider
      value={{
        tool,
        invalidateToolQuery,
      }}
    >
      {children}
    </ToolDataContext.Provider>
  );
};

export const useToolDataContext = () => {
  const value = useContext(ToolDataContext);

  if (value === undefined) {
    throw new ContextOutOfBoundsError("ToolDataContext");
  }

  return value;
};
